window.collapsibleContent = (() => {
  if (!window.collapsibleContent) {
    const closeAllExceptCurrent = (currentItem, items) => {
      items.forEach((item) => {
        if (item !== currentItem && item.hasAttribute("open")) {
          const content = item.querySelector("div"); // Assuming the content is within a div
          content.classList.add("fade-out");
          setTimeout(() => {
            item.removeAttribute("open");
            content.classList.remove("fade-out");
          }, 500); // Wait for 1 second before closing
        }
      });
    };

    const toggleDetails = (item, items) => {
      const isOpen = item.hasAttribute("open");
      const content = item.querySelector("div"); // Adjust selector as needed

      if (isOpen) {
        // Start fade-out animation
        content.classList.add("fade-out");
        setTimeout(() => {
          item.removeAttribute("open");
          content.classList.remove("fade-out");
        }, 500); // Wait for 1 second before closing
      } else {
        // Open the item and close others
        item.setAttribute("open", "");
        closeAllExceptCurrent(item, items);
      }
    };


    const addClickListener = (item, items) => {
      item.querySelector("summary").addEventListener("click", (e) => {
        e.preventDefault();
        toggleDetails(item, items)
      });
    };

    const initializeFaqItems = () => {
      const faqItems = document.querySelectorAll(".js-collapsible");
      faqItems.forEach((item) => addClickListener(item, faqItems));
    };

    initializeFaqItems();
  }

  return true;
})();
